import { ComponentType, ReactNode, ReactElement, lazy } from 'react';
import { withSuspense } from '@/shared/HOC/with-suspense';


export function withLazy<P extends JSX.IntrinsicAttributes> (
    factory: () => Promise<{ default: ComponentType<P> }>,
    componentName: string,
    fallback: ReactNode = null
) {
    const Component           = lazy(factory);
    const SuspendedComponent  = withSuspense(Component, fallback);
    const LazyComponent       = (props: P): ReactElement => <SuspendedComponent { ...props }/>;
    LazyComponent.displayName = 'Lazy' + componentName;

    return LazyComponent;
}
